import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/src/components/designSystem/SkeletonLoader'

const FAQSkeletonLine = ({isLast = false}: {isLast?: boolean}) => {
  return (
    <Box
      paddingBottom={isLast ? '0' : 's500'}
      paddingTop="s500"
      display="flex"
      justifyContent="flex-start"
      gap="s500"
      alignItems="center"
    >
      <SkeletonLoader width={150} marginTop={0} />
    </Box>
  )
}

export const SkeletonLoaderMobile = () => {
  return (
    <>
      <Box paddingBottom="s700">
        <Box paddingBottom="s400">
          <SkeletonLoader width={100} />
        </Box>
        <FAQSkeletonLine />
        <FAQSkeletonLine />
        <FAQSkeletonLine />
        <FAQSkeletonLine isLast />
      </Box>
    </>
  )
}

export const SkeletonLoaderDesktop = () => {
  return (
    <>
      <Box paddingBottom="s700">
        <Box paddingBottom="s400">
          <SkeletonLoader width={100} />
        </Box>
        <Box display="flex" gap="s500">
          <Box width="50%">
            <FAQSkeletonLine />
            <FAQSkeletonLine />
            <FAQSkeletonLine />
          </Box>
          <Box width="50%">
            <FAQSkeletonLine />
            <FAQSkeletonLine />
            <FAQSkeletonLine />
          </Box>
        </Box>
      </Box>
    </>
  )
}
